import { render, staticRenderFns } from "./BodyguardServiceAdminClient.vue?vue&type=template&id=7ebae00f"
import script from "./BodyguardServiceAdminClient.vue?vue&type=script&lang=js"
export * from "./BodyguardServiceAdminClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports